
/**
 * 미디어 유형
 */
export type UploadMedia201Type = typeof UploadMedia201Type[keyof typeof UploadMedia201Type];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UploadMedia201Type = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  GIF: 'GIF',
  AUDIO: 'AUDIO',
  LINK: 'LINK',
} as const;
